module.exports = __webpack_public_path__ + "assets/img/k-c-bg.a1a1f23c.png";